// API Configuration
// Production: https://auth-backend.nordbyjonathan.workers.dev
// Development: http://localhost:8787
export const API_URL = process.env.REACT_APP_API_URL || 'https://auth-backend.nordbyjonathan.workers.dev';
